import { render } from "./HzbaSeparator.vue?vue&type=template&id=a4a1981c"
import script from "./HzbaSeparator.vue?vue&type=script&lang=js"
export * from "./HzbaSeparator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__